// ProRoute.js
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import RulesModal from "./community/RulesModal";
import "./ProRoute.css";
import { logEvent } from "firebase/analytics";
import { analytics } from "./analytics";


function ProRoute({ user, children }) {
  const [plan, setPlan] = useState(null);
  const [credits, setCredits] = useState(0);
  const [testerPro, setTesterPro] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isPro, setIsPro] = useState(false);


  const [hasTrackedPurchase, setHasTrackedPurchase] = useState(false);
  const [prevIsPro, setPrevIsPro] = useState(null);

  
  // 🔥 ADMIN UID (replace with your real UID)
  const ADMIN_UID = "L58LMIJJycTGSrLm1Vqrajmlapa2";




  useEffect(() => {
    if (!user) {
      setPlan("free");
      setLoading(false);
      return;
    }

    const loadUserData = async () => {
      try {
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);

        if (snap.exists()) {
       const data = snap.data();
const userIsPro = Boolean(data.isPro);

setIsPro(userIsPro);

// 🔥 TRACK ONLY ON TRANSITION (FREE → PRO)
if (userIsPro && !hasTrackedPurchase && data.proSince) {
  if (analytics) {
    logEvent(analytics, "purchase", {
      transaction_id: user.uid + "_" + data.proSince?.seconds,
      value: 5.99,
      currency: "USD",
      items: [
        {
          item_name: "EmployPilot Pro",
          item_category: "subscription",
          price: 5.99,
          quantity: 1
        }
      ]
    });
  }

  setHasTrackedPurchase(true);
}


          // Unified plan model
          setPlan(data.plan || "free");

          // If the user has Quick Resume credits
          setCredits(data.credits || 0);

          //TestFlight users
          setTesterPro(Boolean(data.testerPro));

          // Rules acceptance
        } else {
          // If user doc is missing — create a default one
          await updateDoc(ref, {
            plan: "free",
            credits: 0,
            rulesAccepted: false,
            email: user.email,
          });

          setPlan("free");
          setCredits(0);
        }
      } catch (e) {
        console.error("❌ Error loading user data:", e);
        setPlan("free");
      }

      setLoading(false);
    };

    loadUserData();
  }, [user]);

  // ============================
  //  LOADING SCREEN
  // ============================
  if (loading) {
    return <div className="pro-loading">Checking access...</div>;
  }

  // ============================
  //  ADMIN OVERRIDE
  // ============================
  if (user && user.uid === ADMIN_UID) {

    return children;
  }


  // ============================
  //  PLAN CHECK — PRO ONLY
  // ============================
 const hasProAccess = plan === "pro" || testerPro;



if (!hasProAccess) {
  return (
    <div className="pro-paywall-wrapper">
      <div className="pro-paywall-card">
        <h2 className="pro-title">Unlock AI Career Tools</h2>

        <p className="pro-desc">
          This feature is included in <strong>EmployPilot Pro</strong> only.
        </p>

        <button
          type="button"
          className="pro-upgrade-btn"
          onClick={() => navigate("/pricing")}
        >
          Upgrade to Pro
        </button>

        <button
          type="button"
          className="pro-cancel-btn"
          onClick={() => navigate("/")}
        >
          Go Back
        </button>
      </div>
    </div>
  );
}

  // ============================
  //  ACCESS GRANTED
  // ============================
  return children;
}

export default ProRoute;

